var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.6,
    height: 31.631,
    viewBox: "0 0 31.6 31.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "awards",
    transform: "translate(-0.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M3.522,314.594l-3,3a.927.927,0,0,0,.381,1.54l5.344,1.659L7.9,326.138a.927.927,0,0,0,1.54.381l4.677-4.677a14.364,14.364,0,0,1-10.6-7.247Z",
    transform: "translate(0 -295.159)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M300.809,317.595l-3-3a14.364,14.364,0,0,1-10.6,7.247l4.677,4.677a.927.927,0,0,0,1.54-.381l1.659-5.344,5.344-1.659a.927.927,0,0,0,.38-1.54Z",
    transform: "translate(-269.231 -295.159)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M149.043,88a7.043,7.043,0,1,0,7.043,7.043A7.051,7.051,0,0,0,149.043,88Zm3.455,8.323.105,2.464a.927.927,0,0,1-1.249.908l-2.311-.861-2.311.861a.927.927,0,0,1-1.25-.908l.105-2.464-1.533-1.932a.927.927,0,0,1,.477-1.469l2.376-.661,1.363-2.055a.927.927,0,0,1,1.544,0l1.363,2.055,2.376.661a.927.927,0,0,1,.477,1.469Z",
    transform: "translate(-132.993 -82.563)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M216.258,160.316l-.782-1.179-.782,1.179a.927.927,0,0,1-.524.381l-1.363.379.879,1.108a.927.927,0,0,1,.2.616l-.06,1.413,1.325-.494a.926.926,0,0,1,.647,0l1.325.494-.06-1.413a.927.927,0,0,1,.2-.616l.88-1.108-1.363-.379A.927.927,0,0,1,216.258,160.316Z",
    transform: "translate(-199.427 -149.306)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M78.959,12.479A12.479,12.479,0,1,0,66.479,24.959,12.493,12.493,0,0,0,78.959,12.479Zm-12.479,8.9a8.9,8.9,0,1,1,8.9-8.9A8.906,8.906,0,0,1,66.479,21.375Z",
    transform: "translate(-50.43 0)",
    fill: "#4e3057"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwards);
export default __webpack_public_path__ + "static/media/awards.81513f487c881783642221ffb85b076d.svg";
export { ForwardRef as ReactComponent };